import {
  Alert,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import { useTranslation } from "react-i18next";
import { RoleComponentGuard } from "../../Reuseables/Guards/RoleComponentGuard";

import { DownloadSizeGuide } from "../../Reuseables/Links/Links";
import ProjectCodeBox from "../../Reuseables/ProjectCodeBox";
import { Project } from "../../../types/project";
import { Role } from "../../../types/enums";

type NotStartedViewIntroProps = {
  project: Project;
};
export default function NotStartedViewIntro({
  project,
}: NotStartedViewIntroProps) {
  const { t } = useTranslation();
  return (
    <Box>
      <Box>
        <Typography fontSize={30} variant="h5">
          {t("notStartedPage.text1")}
        </Typography>
      </Box>
      <RoleComponentGuard
        roles={[Role.PrecureAdmin, Role.LocalCoordinator, Role.SolutionOwner, Role.Partner]}
      >
        <Box>
          <Typography mt={2}>{t("notStartedPage.text2")}</Typography>

          <Typography mt={2}>{t("notStartedPage.text13")}</Typography>
        </Box>
      </RoleComponentGuard>
      <Box>
        <List disablePadding>
          <ListItem disableGutters>
            <ListItemAvatar>
              <LooksOneIcon color="primary" />
            </ListItemAvatar>
            <ListItemText>
              {t("notStartedPage.text3")}{" "}
              <DownloadSizeGuide deviceTypes={project.deviceType} />{" "}
              {t("notStartedPage.text14")}
            </ListItemText>
          </ListItem>
          <ListItem disableGutters>
            <ListItemAvatar>
              <LooksTwoIcon color="primary" />
            </ListItemAvatar>
            <ListItemText>{t("notStartedPage.text4")}</ListItemText>
          </ListItem>
          <ListItem disableGutters>
            <ListItemAvatar>
              <Looks3Icon color="primary" />
            </ListItemAvatar>
            <ListItemText>{t("notStartedPage.text5")}</ListItemText>
          </ListItem>
        </List>
      </Box>

      <ProjectCodeBox projectCode={project.projectCode} />

      <Box mt={2}>
        <Alert severity="info">{t("alerts.startMeasurement")}</Alert>
      </Box>
    </Box>
  );
}
